
import { List, ListItem, styled, Tooltip, tooltipClasses, TooltipProps } from "@mui/material";
import dayjs from "dayjs";
import React from "react";
import { useTranslation } from "react-i18next";
import { IOneWay, IStopSell } from "../../../types";

interface TooltipAvailabilitiesProps extends Omit<TooltipProps, 'title'> {
    oneWayInS: IOneWay[],
    stopSells: IStopSell | null
};

const TooltipAvailabilities = styled(({
    className,
    oneWayInS,
    stopSells,
    ...props
}: TooltipAvailabilitiesProps) => {

    const { t } = useTranslation('booking');

    return (
        <Tooltip
            {...props}
            title={
                <List >
                    {oneWayInS?.map((ow, i) => (
                        <React.Fragment key={i}>
                            <ListItem>
                                {t('label.oneWayIn') + `: from ${ow.location ?? ''}, ${dayjs(ow.date).format('DD/MM/YYYY') ?? ''}, ${ow.product ?? ''}`}
                            </ListItem>
                        </React.Fragment>
                    ))}
                    {stopSells &&
                        <>
                            <ListItem>
                                {t('label.stopSell') + `: ${stopSells?.ruleName ?? ''}`}
                            </ListItem>
                        </>
                    }
                </List>
            }
            classes={{ popper: className }}
        />
    )
})(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        padding: 0,
        fontSize: '.8rem',
        maxWidth: 400,
    },
}));

export default TooltipAvailabilities;